<template>
  <div> <!-- Only one element for Transition -->
    <div v-if="(!participation?.documents || (participation?.documents.length ?? 0) === 0)" class="text-muted">
      Aucun document demand&eacute;
    </div>
    <div v-else>
      <div v-for="(doc, idx) in participation.documents" :key="doc.id" class="card mb-3">
        <div class="card-header d-flex justify-content-between align-items-center bg-light">
          <div>
            <h5 class="mb-0">
              {{ doc.label }}
              <small>
                <span v-if="doc.required" class="badge bg-success ms-2">Requis(e)</span>
              </small>
            </h5>
          </div>
          <div v-if="doc.subTitle" class="text-muted small fst-italic">( {{ doc.subTitle }} )</div>
        </div>
        <div class="card-body">
          <FileUploadComponent
            :type="doc.type === TravelDbDocumentTypeEnum.Image ? 'image' : (doc.type === TravelDbDocumentTypeEnum.Pdf ? 'pdf' : 'file')"
            :value-key="`documents[${idx}].file`"
            :required="doc.required"
            :maxFileSize="30"
            class="mb-3"
            :height="doc.type === TravelDbDocumentTypeEnum.Image ? '250px' : '150px'"
            style="max-height:50vh"
            :display-max-height="doc.type === TravelDbDocumentTypeEnum.Image ? 250 : 150"
            :hideIcon="true"
          />
          <div v-if="(documentInstructions(doc.id)?.length ?? 0) > 0"
            class="ql-editor"
            v-html="normalizeRichTextContent(documentInstructions(doc.id))">
          </div>
        </div>
      </div>

      <template v-if="(participation.companions?.length ?? 0) > 0 && participation.documents.some(d => d.alsoForCompanion)">
        <div v-for="(companion, companionIdx) in participation.companions" :key="companionIdx" class="mt-4">
          <template v-if="companion.documents && companion.documents.length > 0">
            <h5 class="mb-3">
              <i class="fa-solid fa-user me-2"></i>
              {{ GetCompanionLabel(participation.travel.companionLabel, 1, true) }} {{ companionIdx + 1 }} — {{ companion.firstName }} {{ companion.lastName?.toUpperCase() }}
            </h5>
            <div v-for="(doc, docIdx) in companion.documents" :key="doc.id" class="card mb-3">
              <div class="card-header d-flex justify-content-between align-items-center bg-light">
                <div>
                  <h5 class="mb-0">
                    {{ doc.label }}
                    <small>
                      <span v-if="doc.required" class="badge bg-success ms-2">Requis(e)</span>
                    </small>
                  </h5>
                </div>
                <div v-if="doc.subTitle" class="text-muted small fst-italic">
                  ( {{ doc.subTitle }} )
                </div>
              </div>
              <div class="card-body">
                <FileUploadComponent
                  :type="doc.type === TravelDbDocumentTypeEnum.Image ? 'image' : (doc.type === TravelDbDocumentTypeEnum.Pdf ? 'pdf' : 'file')"
                  :value-key="`companions[${companionIdx}].documents[${docIdx}].file`"
                  :required="doc.required"
                  :maxFileSize="30"
                  class="mb-3"
                  :height="doc.type === TravelDbDocumentTypeEnum.Image ? '250px' : '150px'"
                  style="max-height:50vh"
                  :display-max-height="doc.type === TravelDbDocumentTypeEnum.Image ? 250 : 150"
                  :hideIcon="true"
                />
                <div v-if="(documentInstructions(doc.id)?.length ?? 0) > 0"
                  class="ql-editor"
                  v-html="normalizeRichTextContent(documentInstructions(doc.id))">
                </div>
              </div>
            </div>
          </template>
        </div>
      </template>
    </div>

    <PageBottomMessage  message-key="pageDocuments"></PageBottomMessage>
  </div>
</template>
<script setup lang="ts">
import { GetCompanionLabel, normalizeRichTextContent } from '@/compositions/helper';
import { useTravelConfigStore } from '@/stores/travelConfigStore';

const participation = defineModel<UserParticipation>();

const travelConfigStore = useTravelConfigStore();
const documentInstructions = (documentId: number) => {
  return travelConfigStore.travelDocumentInstructions.find(instr => instr.documentId === documentId)?.instruction ?? '';
}
</script>
